import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ed10192"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "js-page-content",
  role: "main",
  class: "page-content"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"row\" data-v-2ed10192><div class=\"subheader col-6\" data-v-2ed10192><h1 class=\"subheader-title\" data-v-2ed10192>売上分析</h1></div><div class=\"subheader-block ml-auto demo\" data-v-2ed10192><button type=\"button\" class=\"btn btn-success waves-effect waves-themed\" data-v-2ed10192><span class=\"fal fa-download mr-1\" data-v-2ed10192></span>分析条件を保存 </button></div></div><div class=\"row\" data-v-2ed10192><div class=\"col-sm-6 col-xl-3\" data-v-2ed10192><div class=\"p-3 bg-primary-300 rounded overflow-hidden position-relative text-white mb-g\" data-v-2ed10192><div class=\"\" data-v-2ed10192><h3 class=\"display-4 d-block l-h-n m-0 fw-500\" data-v-2ed10192> ¥1,000,00,000- <small class=\"m-0 l-h-n\" data-v-2ed10192>当期売上実績</small></h3></div><i class=\"fal fa-yen-sign position-absolute pos-right pos-bottom opacity-15 mb-n1 mr-n1\" style=\"font-size:6rem;\" data-v-2ed10192></i></div></div><div class=\"col-sm-6 col-xl-3\" data-v-2ed10192><div class=\"p-3 bg-warning-400 rounded overflow-hidden position-relative text-white mb-g\" data-v-2ed10192><div class=\"\" data-v-2ed10192><h3 class=\"display-4 d-block l-h-n m-0 fw-500\" data-v-2ed10192> ¥1,000,00,000- <small class=\"m-0 l-h-n\" data-v-2ed10192>当期粗利実績</small></h3></div><i class=\"fal fa-gem position-absolute pos-right pos-bottom opacity-15 mb-n1 mr-n4\" style=\"font-size:6rem;\" data-v-2ed10192></i></div></div><div class=\"col-sm-6 col-xl-3\" data-v-2ed10192><div class=\"p-3 bg-success-200 rounded overflow-hidden position-relative text-white mb-g\" data-v-2ed10192><div class=\"\" data-v-2ed10192><h3 class=\"display-4 d-block l-h-n m-0 fw-500\" data-v-2ed10192> 87.65% <small class=\"m-0 l-h-n\" data-v-2ed10192>当期売上目標充足率</small></h3></div><i class=\"fal fa-lightbulb position-absolute pos-right pos-bottom opacity-15 mb-n5 mr-n6\" style=\"font-size:8rem;\" data-v-2ed10192></i></div></div><div class=\"col-sm-6 col-xl-3\" data-v-2ed10192><div class=\"p-3 bg-info-200 rounded overflow-hidden position-relative text-white mb-g\" data-v-2ed10192><div class=\"\" data-v-2ed10192><h3 class=\"display-4 d-block l-h-n m-0 fw-500\" data-v-2ed10192> 53.65% <small class=\"m-0 l-h-n\" data-v-2ed10192>当期期間消化率</small></h3></div><i class=\"fal fa-globe position-absolute pos-right pos-bottom opacity-15 mb-n1 mr-n4\" style=\"font-size:6rem;\" data-v-2ed10192></i></div></div></div>", 2)
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-xl-12" }
const _hoisted_6 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel-hdr" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "分析条件"),
  /*#__PURE__*/_createElementVNode("div", { class: "panel-toolbar" }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-collapse",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Collapse"
    }),
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-fullscreen",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Fullscreen"
    })
  ])
], -1))
const _hoisted_8 = { class: "panel-container show" }
const _hoisted_9 = { class: "panel-content contents" }
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"row\" data-v-2ed10192><div class=\"col-md-1 contTitle\" data-v-2ed10192>集計期間</div><div class=\"col-md-5 contCnt input-daterange input-group\" data-v-2ed10192><div class=\"input-daterange input-group\" id=\"datepicker-5\" data-v-2ed10192><input type=\"date\" class=\"form-control\" name=\"start\" data-v-2ed10192><div class=\"input-group-append input-group-prepend\" data-v-2ed10192><span class=\"input-group-text fs-xl\" style=\"height:35px;\" data-v-2ed10192>～</span></div><input type=\"date\" class=\"form-control\" name=\"end\" data-v-2ed10192></div></div><div class=\"col-md-1 contTitle\" data-v-2ed10192>案件名</div><div class=\"col-md-5 contCnt\" data-v-2ed10192><input type=\"text\" name=\"txtAnkenNm\" id=\"txtAnkenNm\" maxlength=\"200\" class=\"example3 number form-control form-control-sm\" data-v-2ed10192></div></div>", 1)
const _hoisted_11 = { class: "row" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "広告主", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-5 contCnt" }, [
  /*#__PURE__*/_createElementVNode("input", {
    type: "text",
    name: "txtKoukokuNm",
    id: "txtKoukokuNm",
    maxlength: "200",
    class: "example3 number form-control form-control-sm"
  })
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "売上先", -1))
const _hoisted_15 = { class: "col-md-5 contCnt" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "営業担当", -1))
const _hoisted_18 = { class: "col-md-5 contCnt" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "ジャンル", -1))
const _hoisted_20 = { class: "col-md-5 contCnt" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "業種", -1))
const _hoisted_23 = { class: "col-md-5 contCnt" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "商品種別", -1))
const _hoisted_25 = { class: "col-md-5 contCnt" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 contCnt text-center" }, [
    /*#__PURE__*/_createElementVNode("button", {
      type: "button",
      class: "btn btn-primary waves-effect waves-themed btn-search mx-auto"
    }, " 分析開始 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 contCnt text-center" }, [
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("small", null, " 指定条件によって分析には時間がかかる場合があります ")
    ])
  ])
], -1))
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-xl-12" }
const _hoisted_29 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel-hdr" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "売上詳細"),
  /*#__PURE__*/_createElementVNode("div", { class: "panel-toolbar" }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-collapse",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Collapse"
    }),
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-fullscreen",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Fullscreen"
    })
  ])
], -1))
const _hoisted_31 = { class: "panel-container show" }
const _hoisted_32 = { class: "panel-content contents" }
const _hoisted_33 = { class: "row" }
const _hoisted_34 = { class: "col-xl-12" }
const _hoisted_35 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel-hdr" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "商品種別累計売上"),
  /*#__PURE__*/_createElementVNode("div", { class: "panel-toolbar" }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-collapse",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Collapse"
    }),
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-fullscreen",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Fullscreen"
    })
  ])
], -1))
const _hoisted_37 = { class: "panel-container show" }
const _hoisted_38 = { class: "panel-content contents" }
const _hoisted_39 = { class: "row" }
const _hoisted_40 = { class: "col-lg-5" }
const _hoisted_41 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel-hdr" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "構成割合"),
  /*#__PURE__*/_createElementVNode("div", { class: "panel-toolbar" }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-collapse",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Collapse"
    }),
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-fullscreen",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Fullscreen"
    })
  ])
], -1))
const _hoisted_43 = { class: "panel-container show" }
const _hoisted_44 = { class: "panel-content border-faded border-left-0 border-right-0 border-top-0 text-muted d-flex" }
const _hoisted_45 = { class: "panel-content contents" }
const _hoisted_46 = /*#__PURE__*/_createStaticVNode("<div class=\"col-lg-7\" data-v-2ed10192><div id=\"panel-1\" class=\"panel\" data-v-2ed10192><div class=\"panel-hdr\" data-v-2ed10192><h2 data-v-2ed10192>エリア別商品分布</h2><div class=\"panel-toolbar\" data-v-2ed10192><button class=\"btn btn-panel\" data-action=\"panel-collapse\" data-toggle=\"tooltip\" data-offset=\"0,10\" data-original-title=\"Collapse\" data-v-2ed10192></button><button class=\"btn btn-panel\" data-action=\"panel-fullscreen\" data-toggle=\"tooltip\" data-offset=\"0,10\" data-original-title=\"Fullscreen\" data-v-2ed10192></button></div></div><div class=\"panel-container show\" data-v-2ed10192><img src=\"/img/jpnmap.png\" alt=\"\" style=\"width:100%;max-width:830px;max-height:520px;\" data-v-2ed10192></div></div></div>", 1)
const _hoisted_47 = { class: "row" }
const _hoisted_48 = { class: "col-xl-12" }
const _hoisted_49 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel-hdr" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "対象案件一覧"),
  /*#__PURE__*/_createElementVNode("div", { class: "panel-toolbar" }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-collapse",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Collapse"
    }),
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-fullscreen",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Fullscreen"
    })
  ])
], -1))
const _hoisted_51 = { class: "panel-container show" }
const _hoisted_52 = { class: "panel-content" }
const _hoisted_53 = {
  key: 0,
  class: "gtablecell btnDetCell"
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-xs btn-block btn-primary waves-effect waves-themed"
}, " 詳細 ", -1))
const _hoisted_55 = [
  _hoisted_54
]
const _hoisted_56 = {
  key: 1,
  class: "gtablecell"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vSelect = _resolveComponent("vSelect")!
  const _component_Mo_chart_barline = _resolveComponent("Mo_chart_barline")!
  const _component_Mo_chart_doughnut = _resolveComponent("Mo_chart_doughnut")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _hoisted_13,
                _hoisted_14,
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_vSelect, {
                    multiple: "",
                    options: _ctx.optionsOp
                  }, null, 8, ["options"])
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_vSelect, {
                    multiple: "",
                    options: _ctx.optionsOp2
                  }, null, 8, ["options"])
                ]),
                _hoisted_19,
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_vSelect, {
                    multiple: "",
                    options: _ctx.optionsOp3
                  }, null, 8, ["options"])
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(_component_vSelect, {
                    multiple: "",
                    options: _ctx.optionsOp4
                  }, null, 8, ["options"])
                ]),
                _hoisted_24,
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_vSelect, {
                    multiple: "",
                    options: _ctx.optionsOp5
                  }, null, 8, ["options"])
                ])
              ]),
              _hoisted_26
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_27, [
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _hoisted_30,
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              (_ctx.reRender)
                ? (_openBlock(), _createBlock(_component_Mo_chart_barline, {
                    key: 0,
                    chartData: _ctx.chartData4d2,
                    options: _ctx.chartOptions4d2
                  }, null, 8, ["chartData", "options"]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_33, [
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("div", _hoisted_35, [
          _hoisted_36,
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              (_ctx.reRender)
                ? (_openBlock(), _createBlock(_component_Mo_chart_barline, {
                    key: 0,
                    chartData: _ctx.chartData4d4,
                    options: _ctx.chartOptions4d4
                  }, null, 8, ["chartData", "options"]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_39, [
      _createElementVNode("div", _hoisted_40, [
        _createElementVNode("div", _hoisted_41, [
          _hoisted_42,
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
              _createVNode(_component_Mo_chart_doughnut, {
                style: {"width":"100%","max-height":"230px"},
                chartData: _ctx.chartData4d1,
                options: _ctx.chartOptions4d1
              }, null, 8, ["chartData", "options"])
            ]),
            _createElementVNode("div", _hoisted_45, [
              _createVNode(_component_Mo_chart_doughnut, {
                style: {"width":"100%","max-height":"230px"},
                chartData: _ctx.chartData4d3,
                options: _ctx.chartOptions4d1
              }, null, 8, ["chartData", "options"])
            ])
          ])
        ])
      ]),
      _hoisted_46
    ]),
    _createElementVNode("div", _hoisted_47, [
      _createElementVNode("div", _hoisted_48, [
        _createElementVNode("div", _hoisted_49, [
          _hoisted_50,
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("div", _hoisted_52, [
              _createVNode(_component_vue_good_table, {
                columns: _ctx.columns,
                rows: _ctx.rows,
                "pagination-options": {
                  perPageDropdownEnabled: false,
                  enabled: true,
                  jumpFirstOrLast: true,
                  page: 1,
                  perPage: 20,
                  nextLabel: '次へ',
                  prevLabel: '前へ',
                  mode: 'pages',
                  ofLabel: '～',
                  pageLabel: '',
                },
                totalRows: _ctx.totalRecords
              }, {
                "table-row": _withCtx((props) => [
                  (props.column.field == '詳細ボタン')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_53, _hoisted_55))
                    : (_openBlock(), _createElementBlock("div", _hoisted_56, _toDisplayString(props.formattedRow[props.column.field]), 1))
                ]),
                _: 1
              }, 8, ["columns", "rows", "totalRows"])
            ])
          ])
        ])
      ])
    ])
  ]))
}